<template>
  <v-app id="app" >
    <ed-session ref="session" />
    <ed-socket ref="socket" />
    <ed-request ref="request" :is-online="computedClass"/>
    <ed-notify ref="notify" />
    <ed-dialog ref="dialog" />
    <ed-loading ref="loading" />
    <ed-notification />
    <router-view />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import {
  EdSocket,
  EdSession,
  EdRequest,
  EdNotify,
  EdDialog,
  EdLoading,
} from "components/root";

import { EdNotification } from "template";
import Ping from "ping.js";

export default {
  name: "App",
  components: { EdNotification,EdSocket,EdSession, EdRequest, EdNotify, EdDialog, EdLoading },

  data() {
    return {
      arrayEvent: ["online", "offline", "load"],
      pingUrl:'https://google.com',
      isOnline: navigator.onLine || false,
      policyCookie:'ecs-lgpd-policy'
    };
  },
  created() {
    this.arrayEvent.forEach((event) =>
      window.addEventListener(event, this.updateOnlineStatus)
    );
  },
  mounted() {
    this.$root.$session = this.$refs.session;
    this.$root.$socket = this.$refs.socket;
    this.$root.$request = this.$refs.request;
    this.$root.$notify = this.$refs.notify;
    this.$root.$dialog = this.$refs.dialog;
    this.$root.$loading = this.$refs.loading;

    if(!this.$cookie.get(this.policyCookie)){
      this.setNotificationWarning({content:'Usamos cookies para personalizar o conteúdo, adaptar e medir anúncios, além de oferecer uma experiência mais segura a você. Ao continuar a navegação em nosso site, você concorda com o uso dessas informações. Leia nossa Política de Cookies e saiba mais.',callback:this.setPolicyCookie})
    }
  },
  beforeDestroy() {
    this.arrayEvent.forEach((event) =>
      window.removeEventListener(event, this.updateOnlineStatus),
    );
  },
  computed: {
    computedClass() {

      if(!this.isOnline){
        this.setNotificationError('Verifique sua conexão com a internet')
      }
      else{
        this.setNotificationError(null)
      }

      return this.isOnline;
    },
  },
  watch:{
  },
  methods: {
    ...mapActions("common", ["setNotificationWarning","setNotificationError","setLocation"]),

    setPolicyCookie(){
      this.$cookie.set(this.policyCookie,'accept',{expires:'2Y'})
      this.setNotificationWarning()
    },

    updateOnlineStatus() {
      const t = this;
      const p = new Ping({timeout:5000});
      p.ping(t.pingUrl, (err) => {
        if (err || !navigator.onLine) {
          t.isOnline = false;
          t.$emit("offline", this.isOnline);
        } else {
          t.isOnline = true;
          t.$emit("online", this.isOnline);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue